import { Link, Outlet } from "react-router-dom";

import { AppHeader } from "@vellum/ui";

export function RootLayout() {
  return (
    <div className="flex flex-col">
      <AppHeader
        brand="Hub"
        accent="green"
        renderLink={({ href, className, children }) => (
          <Link to={href} className={className}>
            {children}
          </Link>
        )}
        showLogo
      />
      <main className="mx-auto w-full max-w-7xl flex-1 px-4 py-6 pb-10 sm:px-6 sm:py-8 sm:pb-12 lg:px-8">
        <Outlet />
      </main>
    </div>
  );
}
